import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import {Col, Container, Row} from "react-bootstrap";
import LeftImg from "../Component/assets/images/leftimg.webp";
import logoImg from "../Component/assets/images/logo.png";
import imgBeratung from "../Component/assets/images/beratung.png";
import Header from "./Header";
import Footer from "./Footer";
import ScrollToTop from "../Helper/ScrollToTop";

const Home = () => {
    return (
        <div className="text-light min-vh-100 d-flex flex-column justify-content-between">
            <ScrollToTop/>
            {/* Header and Content in a Single Section */}
            <section className="flex-grow-1">
                <Container fluid className="text-left p-sm-3">
                    <Container>
                        <Row className="div-style text-start">
                            <Col md={9}>
                            <h1 className="display-4">
                                Systemische und Psychoanalytische Beratung
                            </h1>
                            <p className="lead">Für Kinder, Jugendliche und Erwachsene</p>
                            <p>
                                Jeder Mensch hat seinen eigenen Zugang zur Lösung von Herausforderungen.
                                Bei Kindern zeigt sich dies oft spielerisch – beim Zeichnen und Spielen entstehen
                                kreative Lösungsansätze. Jugendliche und Erwachsene wiederum öffnen sich im
                                vertraulichen Gespräch. Durch aufmerksames Zuhören und das szenische Verstehen schaffen
                                wir Raum, in dem sich festgefahrene Muster lösen und neue Perspektiven eröffnen.
                                Manchmal genügt schon ein kleiner Impuls, um den Weg zu mehr Klarheit und innerer
                                Freiheit zu ebnen.
                            </p>

                                <p className="lead">Manchmal genügt ein Anstoß...</p>
                            </Col>
                            <Col md={3}>&nbsp;
                            </Col>
                        </Row>
                        <Row className="rounded">
                            <Col md={6}>
                                <div className="rounded d-flex justify-content-center align-items-center">
                                    <img src={LeftImg} alt="Es lohnt sich, genauer hinzuschauen"
                                         className="img-fluid"
                                         style={{maxHeight: "350px", objectFit: "cover"}}
                                    />
                                </div>
                            </Col>
                            <Col md={6}>
                                <div className="text-left">
                                    <h2>Es lohnt sich, <span
                                        className="bg-light bg-opacity-25 pb-2 ps-2 pe-2 rounded-5">genauer</span> hinzuschauen
                                    </h2>

                                    <p>Sorgt sich Ihr Kind oder erleben Sie es häufig gereizt bzw. gehemmt?</p>
                                    <p>Was wünschen Sie sich von Ihrem Partner und wieso fällt es
                                        Ihnen schwer, es ihm zu sagen?</p>
                                    <p>Gibt es innerhalb der Familie Probleme?</p>
                                    <p>Haben Sie einen Arbeitskonflikt?</p>
                                    <p>Leiden Sie oder Ihr Kind unter einem Verlust?</p>
                                </div>
                            </Col>
                        </Row>
                        <Row className="rounded pt-2">
                            <Col md={9} className="order-2 order-md-1">
                                <div className="text-left">
                                    <h2>Es lohnt sich, <span
                                        className="bg-light bg-opacity-25 pb-2 ps-2 pe-2 rounded-5 opacity-3">gemeinsam</span> hinzuschauen
                                    </h2>

                                    <p>Ärgern Sie sich...<br/>
                                        über Ihr eigenes Verhalten und möchten Neues ausprobieren?</p>
                                    <p>Gibt es...<br/>
                                        zu viel Streit um Enttäuschung mit Ihrem Partner?</p>
                                    <p>Überfordern Sie...<br/>
                                        die Probleme in Ihrer Familie?</p>
                                    <p>Sorgen Sie sich...<br/>
                                        um die Entwicklung Ihres Kindes?</p>

                                </div>
                            </Col>
                            <Col md={3} className="order-1 order-md-2 p-0">
                                <div className="rounded d-flex justify-content-center align-items-center">
                                    <img src={logoImg} alt="Es lohnt sich, genauer hinzuschauen"
                                         className="img-fluid"
                                         style={{maxHeight: "350px", objectFit: "cover"}}
                                    />
                                </div>
                            </Col>
                        </Row>
                        <Row className="text-left div-style my-5">
                            <Col md={6} className="p-0">
                                <div className="rounded d-flex">
                                    <img src={imgBeratung} alt="Es lohnt sich, genauer hinzuschauen"
                                         className="img-fluid"
                                         style={{maxHeight: "350px", objectFit: "cover"}}
                                    />
                                </div>
                            </Col>
                            <Col md={6} className="mt-5">
                                <p className="mb-3">
                                    Die Gespräche finden in einem "geschützten Raum" auf Augenhöhe statt.
                                </p>
                                <p className="mb-3">
                                    Lassen Sie uns in einem kostenfreien Erstgespräch kennenlernen.
                                </p>
                                <p>
                                    Darüber hinaus können wir uns über eine weiterführende professionelle Unterstützung
                                    verständigen.
                                </p>
                                <p>
                                    Ich würde mich freuen, Sie ein Stück Ihres Weges begleiten zu dürfen. <br/>Sprechen
                                    Sie mich an!
                                </p>
                            </Col>
                        </Row>
                    </Container>
                    <Header/>
                </Container>
            </section>

            {/* Footer Section */}
            <Footer/>
        </div>
    );
};

export default Home;
